export const getInvoiceDetailsCardInfo = (invoiceData: any) => {
  let response: any = {};

  // MEDVOL: M10-11303 changes ========================================
  const esc = invoiceData?.escalations?.[0];

  const remarks =
    esc?.escalated_action === "pending"
      ? {
        "Escalated Remark": esc?.escalated_remarks,
        "Escalated Date": esc?.escalated_date
          ? `${new Date(esc?.escalated_date).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}, ${new Date(esc?.escalated_date).toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })}`
          : "-"
      }
      : ["accepted", "rejected"].includes(esc?.escalated_action || "")
        ? {
          "Escalated Remark": esc?.escalated_remarks,
          "Escalated Date": esc?.escalated_date
            ? `${new Date(esc?.escalated_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(esc?.escalated_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}`
            : "-",
          [esc?.escalated_action === "accepted" ? "Escalated Approved By" : "Escalated Rejected By"]: esc?.action_by,
          [esc?.escalated_action === "accepted" ? "Escalated Approved Date" : "Escalated Rejected Date"]: esc?.action_date
            ? `${new Date(esc?.action_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(esc?.action_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}`
            : "-",
          "Company Remark": esc?.action_remarks,
          "Escalated By":esc?.escalated_by //M10-11303
        }
        : {};
  // MEDVOL: M10-11303 changes ========================================

  response = {
    Company: invoiceData?.company_name || "-", // Company name
    "Invoice No.": invoiceData?.invoice?.invoice_number || invoiceData?.stockist_invoice_number || "-", // Invoice number
    "Invoice Date": invoiceData?.invoice?.new_invoice_date
      ? `${new Date(invoiceData.invoice.new_invoice_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(invoiceData.invoice.new_invoice_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "File Upload Date": invoiceData?.created_date
      ? `${new Date(invoiceData.created_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(invoiceData.created_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "Order Number": invoiceData?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "-",
    "Counter Code": invoiceData?.counter_code || "-", // Counter //M10-11303
    "Counter Name": invoiceData?.orderCodes?.[0]?.reference_order?.novu_metadata?.counter_name|| "-", // Counter //M10-11303
    FUID: invoiceData?.fuid_no || "-", // FUID#
    "Pharmacy Name": invoiceData?.pharmacy_name || "-", // Pharmacy name
    "Pharmacy Code": invoiceData?.pharmacy_code || "-", // Pharmacy code //M10-11303
    City: invoiceData?.state_district_city || "-", // City
    "Link Type": invoiceData?.link_type || "-", // Link type logic
    Stockist: invoiceData?.stockist_name || "-",
    "Stockist Code (CMP)": invoiceData?.company_stockist_code || "-",
    "Stockist Code (MV)": invoiceData?.stockist_medvol_code || "-",
    "Entered By": invoiceData?.invoice?.entered_by || "-",
    "Approved By": invoiceData?.invoice?.approved_by || "-",
    ...remarks // MEDVOL: M10-11303 changes ========================================
  };

  return response;
};

export const getInvoiceDetailsInfo = (invoiceDetails: any) => {
  let response: any = {};

  response = {
    Company: invoiceDetails?.company_name || "-",
    Stockist: invoiceDetails?.stockist_name || "-",
    "GST Applicability": invoiceDetails?.invoice?.gst_validated === true ? "Yes" : "No",  //M10-11546
    "Invoice no.": invoiceDetails?.invoice?.invoice_number || String(invoiceDetails?.stockist_invoice_number) || "-",
    "Stockist code": invoiceDetails?.stockist_medvol_code || "-",
    "GST No.": invoiceDetails?.counter_gst_number || " ",

    "Invoice date": invoiceDetails?.invoice?.new_invoice_date || " ",
    Pharmacy: invoiceDetails?.pharmacy_name || "-",
    "E-Inv.Applicability": invoiceDetails?.is_einv_applicable === true ? "Yes" : "No",

    // "Reference ID": invoiceDetails?.reference_no || "-",
    "Pharmacy code": invoiceDetails?.pharmacy_code || "-",
    "QR/IRN": invoiceDetails?.invoice?.e_inv_ref_type || " ",
    "Order Code": invoiceDetails?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "-",
    Counter: invoiceDetails?.counter_name || "-",
    "Irn Number": invoiceDetails?.invoice?.irn || " ",
    "Link Type": invoiceDetails?.link_type || "-",

    "Counter code": invoiceDetails?.counter_code || "-",
    ...((invoiceDetails?.link_type === "DRAPH" || invoiceDetails?.link_type === "INDPH-PH" || invoiceDetails?.link_type === "INDPH-HS")
      &&
      { "DL no.": invoiceDetails?.counter_dl_number || " " }),

    ...(invoiceDetails?.link_type === "DRDS" && {
      "MCI Validated": invoiceDetails?.invoice?.mci_validated === true ? "Yes" : "No",
    }),
    Address: invoiceDetails?.counter_address,
    ...((invoiceDetails?.link_type === "DRAPH" || invoiceDetails?.link_type === "INDPH-PH" || invoiceDetails?.link_type === "INDPH-HS")
      &&
      { "DL Present": invoiceDetails?.invoice?.dl_validated === true ? "Yes" : "No" }),
    ...(invoiceDetails?.link_type === "DRDS" && { "MCI no.": invoiceDetails?.counter_mci_number || " " }),
    "Clinic/Hospital": invoiceDetails?.counter_clinic_name || "-",

    City: invoiceDetails?.state_district_city?.split(",")[2] || "-",
    // "MTD Value": "-",
    FUID: invoiceDetails?.fuid_no || "-",
    "Entered By": invoiceDetails?.invoice?.entered_by || "-",
    "Approved By": invoiceDetails?.invoice?.approved_by || "-",
    "Entered Date": invoiceDetails?.invoice?.entered_date //M10-9780
      ? `${new Date(invoiceDetails.invoice.entered_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(invoiceDetails.invoice.entered_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "Approved Date": invoiceDetails?.invoice?.approved_date //M10-9780
      ? `${new Date(invoiceDetails.invoice.approved_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(invoiceDetails.invoice.approved_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "Location Name": invoiceDetails?.orderCodes?.[0]?.reference_order?.novu_metadata?.counter_location_name ? invoiceDetails?.orderCodes?.[0]?.reference_order?.novu_metadata?.counter_location_name : '-',
    "Location Code": invoiceDetails?.orderCodes?.[0]?.reference_order?.novu_metadata?.counter_location_code ? invoiceDetails?.orderCodes?.[0]?.reference_order?.novu_metadata?.counter_location_code : '-',
    ...(invoiceDetails?.is_einv_applicable && {
      "E-Inv Category": invoiceDetails?.einvack_type_code == "Upload IRN/BarCode along with Invoice" ? "Category 1" : (invoiceDetails?.einvack_type_code == "Upload E-Inv Aknowledgement Copy separately" ? "Category 2" : "Category 3"),
    }),
    ...(invoiceDetails?.stamp_and_seal_required && {
      "Stamp & Sign Status": invoiceDetails?.invoice?.stamp_and_seal_validated == true ? "Yes" : "No",
      "E-Inv": invoiceDetails?.invoice?.is_category_1 == true ? "Yes" : "No",
    }),
    "Auto Entered": invoiceDetails?.invoice?.is_auto_entered == true ? "Yes" : "No",
    "Textracted": invoiceDetails?.invoice?.textract == true ? "Yes" : "No", //M10-11601
    "Po Proportionate Exempt": invoiceDetails?.invoice?.po_proportionate_exempt_invoice == true ? "Yes" : "No", //M10-11703
  };

  return response;
};


export const eInvoiceCardDetailsInfo = (eInvoiceData: any, cardData: any) => {
  let response: any = {};
  // MEDVOL: M10-10639 changes
  response = {
    "Invoice No.": eInvoiceData?.invoice_number || "-",
    "FUID": eInvoiceData?.mapped_fuid_number || "-",
    "IRN No.": eInvoiceData?.irn_number || "-",
    "Stockist Name": cardData?.stockist_name || "-",
    Date: eInvoiceData?.invoice_date || "-",
    "Counter Code": cardData?.counter_code || "-",
    "Order No": cardData?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "-",
    "Link Type": cardData?.link_type || "-",
    "Pharmacy Name": cardData?.pharmacy_name || "-",
    City: cardData?.state_district_city?.split(",")[2] || "-",
    "Stockist Invoice": cardData?.file_path || "-",
    Amount: eInvoiceData?.amount || "-",
    "GST No": eInvoiceData?.seller_gst || "-",
    "Ack. Copy": eInvoiceData?.einvoice_attachment?.einvoice_attachment_path || "-",
    "Stockist Code (CMP)": cardData?.company_stockist_code || "-",
    "Stockist Code (MV)": cardData?.stockist_medvol_code || "-",
    // MEDVOL: M10-10639 changes
  };

  return response;
};

export const DEFAULT_TABLE_DATA = [
  {
    type: "Quantity",
    invoiceData: "",
    orderedData: "",
    modifiedData: "",
    remaining_quantity: "",
    allowed_qty: "",
  },
  {
    type: "Discount %",
    invoiceData: "",
    orderedData: "",
    modifiedData: "",
    // discountValue: "",
  },
  {
    type: "Cash Discount",
    invoiceData: "",
    orderedData: "",
    modifiedData: "",
  },
  {
    type: "Scheme Qty",
    invoiceData: "",
    orderedData: "",
    modifiedData: "",
    allowed_free_qty: "",
  },
  {
    type: "PTR",
    invoiceData: "",
    orderedData: "",
    modifiedData: "",
  },
  {
    type: "MRP",
    invoiceData: "",
    orderedData: "",
    modifiedData: "",
  },
  {
    type: "Price",
    invoiceData: "",
    orderedData: "",
    modifiedData: "",
  },
];

export const searchOptions = [
  { label: "FUID No", value: "fuid_no" },
  { label: "Invoice Number", value: "invoice_number" },
  { label: "Order No", value: "order_no" },
  { label: "Counter Code", value: "counter_code" },
  { label: "Stockist Medvol Code", value: "stockist_medvol_code" },
  { label: "Company Stockist Code", value: "company_stockist_code" },
];

export const searchOptionsEscalate = [
  { label: "FUID No", value: "fuid" },
  { label: "Invoice Number", value: "invoice_number" },
  { label: "Counter Code", value: "counter_code" }
];